import { useEffect, useRef } from "react";
import "vditor/src/assets/less/index.less";
import "./index.less";
import Vditor from "vditor";
import { BASE_CDN_URL } from "../Markdown/const";

interface IMarkdown {
  id?: string;
  mode?: "wysiwyg" | "ir" | "sv";
  initialValue?: string;
  height?: number;
  onChange?: (value: string) => void;
  onComplete?: (value: string) => void;
}

export default function MarkdownEditor(props: IMarkdown) {
  const {
    id = "",
    initialValue = "",
    height = "auto",
    onComplete,
    onChange,
    mode = "wysiwyg",
  } = props;
  const vditorRef = useRef<HTMLDivElement>(null);
  const isComposing = useRef(false);

  useEffect(() => {
    const vditor = new Vditor(`vditor_${id}`, {
      mode,
      preview: {
        mode: "both",
        theme: {
          current: "light",
          path: BASE_CDN_URL + "/dist/css/content-theme",
        },
      },
      height,
      cache: {
        enable: false,
      },
      input: (value) => {
        if (!isComposing.current) { // 非中文输入状态才触发回调
          onChange && onChange(value);
        }
      },
      value: initialValue,
      cdn: BASE_CDN_URL,
    });
    const vditorElement = vditorRef.current;
    if (vditorElement) {
      vditorElement.addEventListener('compositionstart', () => {
        isComposing.current = true;
      });
      vditorElement.addEventListener('compositionend', () => {
        console.log('compositionend',vditor.getValue())
        isComposing.current = false;
        // 手动触发一次输入更新
        onChange && onChange(vditor.getValue());
      });
    }
    return () => {
      if (vditor.vditor) {
        const text = vditor.getValue();
        onComplete && onComplete(text);
      }
    };
  }, []);

  return (
    <div className="vditor">
      <div id={`vditor_${id}`} ref={vditorRef} />
    </div>
  );
}
